import { OptionBase } from '../base/option.base';
import { OptionTypeInterface } from './option.type.interface';
import { Question } from '../../question';
import { OptionDataInterface } from '../base/optionData.interface';
import { SetOptions } from '@schoolbelle/common/object-change-tracker';
export class OptionType extends OptionBase implements OptionTypeInterface {
  get type() {
    return this.get(['type']) || 'base';
  }
  set type(v: string) {
    this.onComposeDestroy(this.type);
    this.onComposeInit(v);
    this.set(['type'], v);
  }
  constructor(
    question: Question,
    option_id: string,
    option_type: string = 'number'
  ) {
    super(question, option_id);
    this.init(option_type);
  }
  /**
   *
   * @param type
   *
   * executed within instance creation.
   * should not put any code that publish change notification system.
   */
  init(type: string) {
    this.set('type', type, { push: 'none' });
  }
  load(
    data: Partial<OptionDataInterface> = {},
    options: SetOptions = undefined
  ) {
    //overide
    super.load({ ...data, type: this.type }, options);
  }
  onComposeInit(...args) {}
  onComposeDestroy(...args) {}
  onComposeFocus(...args) {}
  onComposeBlur(...args) {}
}
